// removed by extract-text-webpack-plugin
module.exports = {"root":"CannedRules__root___puUNO","header":"CannedRules__header___3gFSF","headerText":"CannedRules__headerText___2TCjq","body":"CannedRules__body___2pbdR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CannedRules/CannedRules.scss
// module id = 416
// module chunks = 0